module.exports = __webpack_public_path__ + "img/security-c.e602f8a.svg";